import http from './http';
import { withScope, captureException, captureMessage } from '@sentry/core';

const whitelistStatus = [200, 201];

export default ({ cache, headers, timeout, ...requestObject }) => {
  return new Promise((resolve, reject) => {
    http({ cache, headers, timeout })
      .request(requestObject)
      .then(response => {
        if (!whitelistStatus.includes(response.status)) {
          withScope(scope => {
            scope.setExtra('response', response);
            scope.setExtra('requestObject', requestObject);
            captureMessage(`Status: ${response.status}`);
          });
        }

        resolve(response.data);
      })
      .catch(error => {
        withScope(scope => {
          scope.setExtra('error', error);
          captureException(error);
        });

        reject(error);
      });
  });
};
